import { InjectionKey } from 'vue';

export const fanConsentRepositoryKey: InjectionKey<FanConsentRepository> = Symbol();

export interface FanConsentRepository {
  init(): void;
  showConsentModal(): void;
}
